<template>
    <v-container fluid class="mx-0 px-0">
        <v-row>
            <v-col cols="12">
                <v-chip-group
                    v-model="option"
                    column
                    mandatory
                >
                    <v-chip
                        v-for="(item, index) in ['Μέσοι Όροι', 'Σύνολο']"
                        :key="index"
                        filter
                        filter-icon="mdi-basketball-hoop"
                        active-class="custom-teal selected-chip"
                        color="white"
                        large
                        mandatory
                        class="text-h5 font-weight-bold"
                    >
                        {{ item }}
                    </v-chip>
                </v-chip-group>
            </v-col>
        </v-row>
        <v-row class="pb-5">
            <v-col
                v-for="([key, value], index) in Object.entries(option ? totalStats : avgStats).slice(0, 6)"
                :key="index"
                cols="4"
                md="2"
                class=" mx-0 px-5"
                style="text-transform: capitalize;"
                align="center"
            >
                <v-card v-if="!$vuetify.breakpoint.mobile" class="elevation-1 py-16" dark>
                    <div class="white--text text-h4 secondary-font font-weight-bold circle-top">
                        {{ value }}
                    </div>
                    <div class="text-h5 font-weight-bold circle-bottom">
                        {{ getText(key) }}
                    </div>
                </v-card>
                <div v-else class="circle-border ">
                    <div class="secondary-font text-h6">
                        {{ value }}
                    </div>
                    <div class="custom-teal-text">
                        {{ getText(key) }}
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="[ option ? totalStats : avgStats ]"
            class="elevation-1  py-3 px-3"
            hide-default-footer
            disable-sort
            :mobile-breakpoint="0"
            :items-per-page="-1"
            style="background: #232323;"
            dark
        >
            <template v-slot:item.free_throw_percentage="{ item }">
                <v-row dense align="center">
                    <v-col cols="12" align="center">
                        {{ `${item.freeThrowAttempts > 0 ? ((item.freeThrowsMade / item.freeThrowAttempts) * 100).toFixed(1) : 0}% ${option ? `(${item.freeThrowsMade} / ${item.freeThrowAttempts})` : ''}` }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.two_points_percentage="{ item }">
                <v-row dense align="center">
                    <v-col cols="12" align="center">
                        {{ `${item.twoPointAttempts > 0 ? ((item.twoPointsMade / item.twoPointAttempts) * 100).toFixed(1) : 0}% ${option ? `(${item.twoPointsMade} / ${item.twoPointAttempts})` : ''}` }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.three_points_percentage="{ item }">
                <v-row dense align="center">
                    <v-col cols="12" align="center">
                        {{ `${item.threePointsMade > 0 ? ((item.threePointsMade / item.threePointAttempts) * 100).toFixed(1) : 0}% ${option ? `(${item.threePointsMade} / ${item.threePointAttempts})` : ''}` }}
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.playTimeInSecs="{ item }">
                <span>
                    {{ secToMinutesSeconds(item.playTimeInSecs) }}
                </span>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    export default {
        props: {
            totalStats: {
                type: Object,
                default: null
            },
            avgStats: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                option: 0,
                headers: [
                    { text: 'PTS', value: 'points', align: 'center' },
                    { text: '2P%', value: 'two_points_percentage', width: '150px', align: 'center' },
                    { text: '3P%', value: 'three_points_percentage', width: '150px', align: 'center' },
                    { text: 'FT%', value: 'free_throw_percentage', width: '150px', align: 'center' },
                    { text: 'OR', value: 'offensiveRebounds', align: 'center' },
                    { text: 'DR', value: 'defensiveRebounds', align: 'center' },
                    { text: 'TR', value: 'rebounds', align: 'center' },
                    { text: 'AST', value: 'assists', align: 'center' },
                    { text: 'STL', value: 'steals', align: 'center' },
                    { text: 'TO', value: 'turnovers', align: 'center' },
                    { text: 'BLK', value: 'blockedShots', align: 'center' },
                    { text: 'FC', value: 'personalFouls', align: 'center' },
                    { text: 'EFF', value: 'pir', align: 'center' }
                    // { text: 'Min', value: 'playTimeInSecs', align: 'center' }
                ]
            }
        },
        methods: {
            secToMinutesSeconds(ms) {
                if (ms < 0) return '-'
                if (typeof ms !== 'number' || isNaN(ms)) return '-'
                const minutes = Math.floor(ms / 60)
                const seconds = Math.floor(ms % 60)
                if (isNaN(minutes) || isNaN(seconds)) return '-'
                return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
            },
            getText(key) {
                return this.headers.find(header => header.value === key).text
            }
        }
    }
</script>

<style scoped>
.circle-border {
    border-radius: 50%;
    border: 5px solid teal;
    width: 90px;
    height: 90px;
    padding: 15px;
    background: #232323;
    text-align: center;
}

.text-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    letter-spacing: normal !important;
    font-family: Arial, sans-serif !important;
}

.text-h4 {
    font-size: 2.125rem !important;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
}

.top-arc {
    border-width: 2px;
    border-radius: 10px 5% / 20px 25em 30px 35em;
    border-color: teal;
}

.v-chip::before {
    background-color: white !important;
}

.selected-chip {
    color: white;
}

/* Top-only semicircle above the desktop stat card */
.circle-top {
    position: relative;
    overflow: visible; /* allow pseudo-element to show outside */

    /* add top padding so the semicircle doesn't overlap content */

    /* padding-top: 40px; */
}

.circle-top::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0; /* aligned with top edge of the card */
    transform: translate(-50%, -50%); /* center horizontally and move up by half height */
    width: 130px;
    height: 80px;
    border-radius: 50%;
    border: 5px solid teal;
    background: transparent; /* keep interior transparent to show card color */
    box-sizing: border-box;

    /* show only the top half */
    clip-path: inset(0 0 60% 0);
    z-index: 2;
}

@media (max-width: 960px) {
    .circle-top {
        padding-top: 28px;
    }

    .circle-top::before {
        width: 88px;
        height: 88px;
        transform: translate(-50%, -50%);
        border-width: 4px;
    }
}

/* Bottom-only semicircle below the desktop stat label */
.circle-bottom {
    position: relative;
    overflow: visible;
}

.circle-bottom::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0; /* aligned with bottom edge of the label area */
    transform: translate(-50%, 50%); /* center horizontally and push down by half height */
    width: 130px;
    height: 80px;
    border-radius: 50%;
    border: 5px solid teal;
    background: transparent;
    box-sizing: border-box;

    /* show only the bottom half */
    clip-path: inset(60% 0 0 0);
    z-index: 2;
}

@media (max-width: 960px) {
    .circle-bottom {
        padding-bottom: 28px;
    }

    .circle-bottom::after {
        width: 88px;
        height: 88px;
        transform: translate(-50%, 50%);
        border-width: 4px;
    }
}
</style>
